import queryClient from '../../../ReactQuery/client';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { patch } from '../../../redux/api';
import type { LicensingRule, PolicyId } from '../../../types';

type UpdatePolicyRulesRequest = {
  editedRuleId: number;
  editedRule: Partial<LicensingRule>;
};

type UpdatePolicyRulesParams = {
  policyId: PolicyId;
  rules: UpdatePolicyRulesRequest[];
};

const patchPolicyRules = ({ policyId, rules }: UpdatePolicyRulesParams) => {
  return patch<{ newRules: UpdatePolicyRulesRequest[] }>(`/api/policies/${policyId}/rules`, { newRules: rules });
};

/**
 * hook for editing multiple licensing policy rules
 */
export default function useUpdatePolicyRules() {
  return useToastedMutation({
    mutationFn: (params: UpdatePolicyRulesParams) => patchPolicyRules(params),
    errorToastMessage: 'Failed to update rules',
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['policy'] });
    },
  });
}
